import React, { useEffect, useState, useRef } from "react";
import TapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";
import { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import TapHelper from "../../../services/TapHelper";
import Chart from "react-google-charts";
import TapSelect from "../../../components/ui/TapSelect";
import DateService from "../../../services/DateService";
import moment from "moment";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import CurrencyFormatter from "../../../services/CurrencyFormatter";
import Status from "../../../components/ui/Status";
import api from "../../../services/api";


const ThresholdWidget = (props) => {
    const updateMyDashboardRef      =   useRef();
    const access_token              =   useSelector(state => state.auth.access_token)
    const widget_keys               =   useSelector(state => state.app.user_info?.widget_keys || []);
    const allWarehouses             =   useSelector(state => state.app.warehouses ? state.app.warehouses : []);
    const widgetUrl                 =   INVENTORY_API_BASE_URL_2 + "/report/inventory_threshold_analysis"

    const [reload, setReload]               =   useState(false)
    const [widgetData, setWidgetData]       =   useState(null)

    const [thresholdData, setThresholdData] =   useState({
        loading         :   false,
        data            :   [],
        remark_time     :   '',
    })
    const [formData, setFormData]           =   useState({
        warehouses      :   [],
        filterData      :   {
                                canChange: false,
                                search_warehouse_ids: [],
                            }
    })

    useEffect(() => {
        if (!formData.filterData.canChange) return;
        thresholdWidgetData();
    }, [formData.filterData]);

    useEffect(() => {
        setFormData(pre => ({
            ...pre,
            warehouses: allWarehouses.map(w => ({ value: w.id, label: `${w.name} (${w.code})` }))
        }))
        const widget =
            widget_keys?.length > 0
                ? widget_keys.find(w => w.key === "inventory_threshold_analysis_widget")
                : null;
        setWidgetData(widget);
    }, []);

    useEffect(() => {
        if (!reload) return;
        thresholdWidgetData();
        setReload(false);

    }, [reload]);

    useEffect(() => {
        setThresholdData(prev => ({ ...prev, loading: true }));
        const cache = localStorage.getItem('thresholdWidget');
        if (cache) {
            const parsed = JSON.parse(cache);
            const diff = DateService.differenceInSeconds(
                moment(parsed.time, 'DD-MM-YYYY HH:mm A').format()
            );
            if (diff <= 86400) {
                setThresholdData({
                    data: parsed.data,
                    loading: false,
                    remark_time: parsed.time,
                });
                return;
            } else {
                localStorage.removeItem('thresholdWidget');
            }
        }
        thresholdWidgetData();
    }, []);

    const thresholdWidgetData = () => {
        setThresholdData(prev => ({ ...prev, loading: true }));
        let params = {
            ...formData.filterData,
            reload: reload ? 'reload' : false,
            action: "widget"
        };
        api.server2Api.get(widgetUrl, { params: params, headers: { 'Authorization': 'Bearer ' + access_token } })
            .then((response) => {
                const res = response.data;
                setThresholdData({
                    data: res.data,
                    remark_time: res.time,
                    loading: false
                });
                localStorage.setItem('thresholdWidget', JSON.stringify(res));
            }).catch(() => {
                setThresholdData(prev => ({ ...prev, loading: false }));
            });
    }
    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, {
            key: "inventory_threshold_analysis_widget",
            name: "Inventory Threshold Analysis Widget"
        });
    };
    const handleCountClick = (data) => {
        const statusId = data.key;
          const warehouseIds = formData.filterData.search_warehouse_ids;

        const params = new URLSearchParams();
        if (statusId) {
            params.append('status_id', statusId);
        }
       if (warehouseIds && warehouseIds.length > 0) {
            warehouseIds.forEach(id => {
                params.append('warehouse_ids[]', id);
            });
        }
        const url = `/report/inventory_threshold_report?${params.toString()}`;
        window.open(url, '_blank');
    };
    
    return (
        <div className="card mt-3">
            <div className="card-body">
                <div className="row">
                    <div className="col-8">
                        <h6 className="fw-bold primary_color mb-0">Threshold Analysis Widget</h6>
                    </div>

                    <div className="col-3 p0">
                        <TapSelect
                            options={formData.warehouses}
                            changeEvent={(selectedOption) => {
                                 const warehouseIds = selectedOption ? [selectedOption.value] : [];
                                setFormData(pre => ({
                                    ...pre,
                                    filterData: {
                                        ...formData.filterData,
                                        canChange: true,
                                        search_warehouse_ids: warehouseIds
                                    }
                                }))
                            }}
                            value={formData.warehouses.find(u => u.value == formData.filterData.search_warehouse_ids[0])}
                            isSearchable={true}
                            isClearable={true}
                            containerHeight="33px"
                            fontSize="93%"
                            width="99%"
                            placeholder="All Warehouses"
                        />
                    </div>
                    <div className="col-1 px-0 mx-0 text-center">
                        <div className="dropdown">
                            <TapIcon.imageIcon
                                icon={TapIcon.ListActionIcon}
                                alt="action-icon"
                                className="img-fluid px-2 btn btn-light btn-block"
                                data-bs-toggle="dropdown"
                                href="#"
                                role="button"
                                aria-expanded="false"
                            />
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>
                                    Refresh
                                </li>
                                <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>
                                    {!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center ">
                    <div className="col-6">
                        <table className="table table-hover table-bordered  bg-white">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th style={{ width: "50%" }}  >Status</th>
                                    <th style={{ width: "50%" }} > Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {thresholdData.loading
                                    ?
                                    <tr>
                                        <td className="text-center" colSpan="3"><Loader /></td>
                                    </tr>
                                    :
                                    thresholdData.data && thresholdData.data?.length > 0 ?
                                        thresholdData.data.map((d, i) => (
                                            <tr key={i} >
                                                <td><Status color={d.color}>{d.status}</Status> Items</td>
                                                <td className="text-center text-primary cursor_pointer" onClick={() => handleCountClick(d)}>
                                                    {d?.total ? d?.total : "-"}
                                                </td>
                                            </tr>
                                        ))
                                        : <tr><td className="text-center" colSpan="3">No Records Found</td></tr>

                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-6 p0 mt-3 mb-1">
                        {thresholdData.loading
                            ? <Loader />
                            :
                            (thresholdData.data ? (
                                <Chart
                                    chartType="PieChart"
                                    data={[['Status Name', 'Threshold Count']].concat(thresholdData.data.map((d) => { return [d.status, d.total]; }))}
                                    options={{
                                        legend: { position: 'labeled', labeledValueText: 'both' },
                                        pieSliceText: 'none',
                                        chartArea: { width: '90%', height: '90%' },
                                    }}
                                    rootProps={{ 'data-testid': '1' }} />
                            ) : null)}

                    </div>
                </div>
                <div className="col-sm-12 text-muted fs11">
                    Report as of {thresholdData.remark_time}
                </div>
            </div>
            <UpdateMyDashboardForm ref={updateMyDashboardRef} />

        </div>
    );
};

export default ThresholdWidget;